let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ceBn0")).then(() => parcelRequire('8jfzJ'));